module.exports = __webpack_public_path__ + "assets/img/gar8-10.32cb6d32.jpg";